import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Button } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

function CircularProgressWithLabel({ value }) {
  return (
    <Box sx={{ position: "relative", display: "inline-flex" }}>
      <CircularProgress color="success" variant="determinate" value={value} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <span
          variant="caption"
          component="div"
          color="text.secondary"
          style={{ fontSize: "11px" }}
        >
          {`${Math.round(value)}%`}
        </span>
      </Box>
    </Box>
  );
}

CircularProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */
  value: PropTypes.number.isRequired,
};

const CircularWithValueLabel = (props) => {
  const pdfData = props.pdfData;
  const [progress, setProgress] = useState(0);
  const [isProgressComplete, setIsProgressComplete] = useState(false);
  const [isTimeEnded, setIsTimeEnded] = useState(false);
  useEffect(() => {
    let interval;
    if (progress === 100) {
      setIsProgressComplete(true);
      // props.getKnowledge();
    } else {
      interval = setInterval(() => {
        const percentageCompleted = calculatePercentageCompleted();
        setProgress(percentageCompleted);
      }, 1000); // Update every second
    }

    return () => clearInterval(interval);
  }, [progress]);

  useEffect(() => {
    if (isProgressComplete && isTimeEnded === false) {
      let interval;
      const currentTime = new Date();
      interval = setInterval(() => {
        const createdAtTime = new Date(pdfData.created_at);
        const elapsedTimeInSeconds = Math.floor(
          (currentTime - createdAtTime) / 1000
        );
        if (elapsedTimeInSeconds > 0 && elapsedTimeInSeconds < 3600) {
          props.getFileStatusUpdate(props.index, props.pdfData.id);
        } else {
          setIsTimeEnded(!isTimeEnded);
          clearInterval(interval);
        }
      }, 10000);
      return () => clearInterval(interval);
    }
  }, [isProgressComplete]);

  const calculatePercentageCompleted = () => {
    if (pdfData.status === "processing") {
      const currentTime = new Date();
      const createdAtTime = new Date(pdfData.created_at);
      const processingTime = pdfData.processing_time;
      const elapsedTimeInSeconds = Math.floor(
        (currentTime - createdAtTime) / 1000
      );
      const pendingTimeInSeconds = Math.max(
        0,
        processingTime - elapsedTimeInSeconds
      );
      const percentageCompleted =
        ((processingTime - pendingTimeInSeconds) / processingTime) * 100;
      return Math.min(percentageCompleted, 100); // Ensure progress does not exceed 100%
    }
    return 0;
  };

  return (
    <>
      {isProgressComplete ? (
        <span className={`badge bg-inverse-warning`}>Processing</span>
      ) : (
        <Button
          variant="outlined"
          style={{
            textTransform: "capitalize",
            fontSize: "12px",
            color: "#000",
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <CircularProgressWithLabel value={progress} />
          Processing Doc...
        </Button>
      )}
    </>
  );
};

CircularWithValueLabel.propTypes = {
  pdfData: PropTypes.object.isRequired,
};

export default CircularWithValueLabel;
